
if (window.artestBaseDomain == null || window.artestRootDomain == null || window.artestApiDomain == null) { 
	//if (location.host.match(/artest\.net/)) {
	if (location.host.match( /^(((?!\-))(xn\-\-)?[a-z0-9\-_]{0,61}[a-z0-9]{1,1}\.)*(xn\-\-)?([a-z0-9\-]{1,61}|[a-z0-9\-]{1,30})\.[a-z]{2,}$/ )) {
		window.artestBaseDomain = (location.host.match(/dev\.artest\.net/)==null ? "artest.net" : "dev.artest.net");
		window.artestRootDomain = "https://" + window.artestBaseDomain;
		window.artestApiDomain = "https://api." + window.artestBaseDomain;
	} else {
		window.artestBaseDomain = location.host;
		window.artestRootDomain = location.protocol + "//" + window.artestBaseDomain;
		window.artestApiDomain  = location.protocol + "//"+ location.host.match(/([^:]+)(:\d+)?/)[1] + ":1337";
	}
}



angular.module("artest.cookie_notify", [ "ui-notification", "ipCookie", "gettext" ])
.run([ "$templateCache", "ipCookie", "Notification", "gettextCatalog", (function() {
	
	var isShowed   = false;
	var cookieName = "artest-cookies-ok";

	return function( $templateCache, ipCookie, Notification, gettextCatalog ) {

		if (isShowed) return;

		$templateCache.put( 'angular-ui-notification_artest-cookie-notify.html', "<div class='ui-notification'><h3 ng-show='title' ng-bind-html='title'></h3><div class='message' ng-bind-html='message'></div><div style='text-align:right;margin:10px'><button class='btn btn-default' ng-click='kill()'>Selv&auml;!</button></div></div>" );

		try {
			if (ipCookie( cookieName )) return;

			var title = "WeUseCookies-title";
			if (title == (title = gettextCatalog.getString( "WeUseCookies-title" ))) title = "K&auml;yt&auml;mme ev&auml;steit&auml;!";

			var message = "WeUseCookies-message";
			if (message == (message = gettextCatalog.getString( "WeUseCookies-message" ))) message = "K&auml;yt&auml;mme verkkosivustollamme ev&auml;steit&auml; k&auml;ytt&auml;j&auml;kokemuksen parantamiseen, tietojen ker&auml;&auml;miseen verkkosivustomme kehitt&auml;miseen. Ev&auml;steill&auml; optimoimme my&ouml;s verkkosivustomme nopeutta.";
			
			/*********************************
			 * Lisätty 22.9.22, jotta kierretään minifioidussa $compile(template)(scope)'ssa ilmenevä ng-bind-html:n ongelma
			 */
			var _tmpl_html = '<p style="display:inline;line-height:2rem;" class="message">' + message + "</p>";

			if (title) _tmpl_html = '<h3 style="display:inline">' + title + "</h3>" + _tmpl_html;

			$templateCache.put( 'angular-ui-notification_artest-cookie-notify.html', '<div '
				+'class="ui-notification" '
				+'style="bottom:10px;left:10px;right:10px;padding:1em;border-bottom:1px solid #000;background-color:rgba(0,0,0,0.8);color:#fff;width:auto;font-size:1rem;" '
				+'>'
				+"<div style='float:right;text-align:right'><button class='btn btn-sm btn-default' ng-click='kill()'>Selv&auml;!</button></div>"
				+_tmpl_html
				+"</div>" );
			/*********************************/

			Notification.primary({
				title        : title,
				message      : message,
				templateUrl  : "angular-ui-notification_artest-cookie-notify.html",
				positionX    : "left",
				positionY    : "bottom",
				delay        : false,
				closeOnClick : false,
				onClose      : function() {
					
					ipCookie( cookieName, Date.now(), { domain: ".artest.net", path: "/" });

					if (!location.host.match( /artest.net$/ )) {
						ipCookie( cookieName, Date.now(), { path: "/" });
					}
				}
			});

			isShowed = true;

		} catch( err ) {
			console.warn( "ERROR@artest.cookie_notify.provider(artestCookieNotify) ::", err );
		}
	};
})()]);

angular.lowercase = angular.lowercase || function(str){ return str.toLowerCase() }; // Poistettu angular 1.7.9:ssa, mutta osa resursseista tarvitsee

angular.module("artest.user.bar", [
	"artest.cookie_notify",
	"artest.preview.query",
	"gettext",
	"ui-notification",
	"ui.bootstrap",
	"ApiHandler",
	"ipCookie",
	"artestUserAssets"
])

.config([ "$controllerProvider","$provide", function( $controllerProvider, $provide ){
	window.controllerResolverRaw = function controllerResolverRaw( basepath, ctrlStr, filename ){
		return [ "$rootScope", "$q", function( $rootScope, $q ){
			if( Array.isArray( ctrlStr )){
				return $q.all( ctrlStr.map(function(v){
					if( typeof v == "string" ){
						return getController( v );
					} else if( Array.isArray( v )){
						return getController( v[0], v[1] );
					} else throw new Error("Invalid argument");
				}));
			} else {
				return getController( ctrlStr, filename );
			}

			function getController( ctrlStr, filename ){
				if ($controllerProvider.has( ctrlStr ) && !$rootScope.DEV) return;

				filename = filename || ctrlStr;
				filename = filename+".js";
				var path = basepath+filename;

				return jQuery.getScript( path ).then(function( code ){
					code = "//# sourceURL="+ path +"\n"+ code.trim();
					var ctrl = window.eval( code );

					if (!$controllerProvider.has( ctrlStr ) || $rootScope.DEV) {
						$controllerProvider.register( ctrlStr, ctrl );
					}
				})
				.catch(function( err ){
					console.error( err );
				});
			}
		}];
	};

	$controllerProvider.resolver = function( basepath ){
		console.log( "Initiating controllerResolver with basepath", basepath );
		return window.controllerResolver = window.controllerResolverRaw.bind( null, basepath );
	};
	$controllerProvider.resolver( "js/controllers/" );

	if (window.artestBaseDomain!="artest.net") {
		$provide.decorator('translateDirective', [ '$delegate', '$log', '$parse', 'gettextUtil', 'gettextCatalog', function( $delegate, $log, $parse, gettextUtil, gettextCatalog ) {
			var _compileFn = $delegate[0].compile;

			$delegate[0].compile = function( element, attrs ) {
				if (gettextCatalog.debug) {
					try {
						element[0].title += (element[0].title&&": ") + " TRANSLATE: '" + gettextUtil.trim( element.html( )) + "'";
					} catch( err ) { }
				}
				return _compileFn( element, attrs );
			};
			return $delegate;
		}]);
	}

	$provide.decorator('gettextCatalog', [ '$delegate', function( $delegate ) {

		$delegate.aliases = angular.extend( $delegate.aliases || {}, {
			"search_key:datamap_content_tags"      : "ODM.description.content.tags",
			"search_key:datamap_location"          : "ODM.location",
			"search_key:oeuvre_canvas_description" : "Additional information about canvas",
			"search_key:oeuvre_method_description" : "Additional information about methods",
			"search_key:client_artist_name"        : "Artist's stage name"
		});

		$delegate.setAliases = function( obj ){
			angular.merge( $delegate.aliases = $delegate.aliases || {}, obj || {} );
		};

		$delegate.setStrings = (function( setStrings ){
			return function( language, strings ){
				var output = {}
				for (var key in $delegate.aliases) {
					if (strings[ $delegate.aliases[key] ]) {
						output[ key ] = strings[ $delegate.aliases[key] ];
					}
				}
				return setStrings.call( this, language, angular.merge( output, strings ));
			};
		})( $delegate.setStrings );

		$delegate.getStringIfExists = function( string, scope, context ){
			var _t_tmp = $delegate.getString( string, scope, context );
			if ( _t_tmp != string || $delegate.debug ) return _t_tmp;
		}
		return $delegate;
	}]);


	// Lisätään ApiHandleriin menetelmä etsiä haettavaa tietoa DOM'sta!
	$provide.decorator( "$ApiHandler", [ "$delegate", function( $delegate ) {

		$delegate.findOrGet = findOrGet.bind( $delegate );

		return $delegate;

		// @TODO: Lisää parametri params
		function findOrGet( resource ) {
			var response;

			try {

				var element = document.getElementById( "apiserver/v2" + resource );

				if (element) {

					/**
					 * ApiServer palauttaa vain JSON-muotoista tavaraa, joten oletetaan sisällön olevan sitä
					 */

					return { data: JSON.parse( element.innerText ) };
				}
			} catch (error) {
				console.error( error );
			}

			return this.get( resource );
		}

	}]);
}])
.service('$User', ["$rootScope","$q","$ApiHandler","ipCookie","$userAssets","$timeout",
          function( $rootScope,  $q,  $ApiHandler,  ipCookie,  $userAssets,  $timeout )
{

	if (!angular.isFunction( $q.allIterator )) {
		console.warn( "allIterator should be in $q!" );

		/**
		 * [promiseIterator description]
		 * @param  {[type]} arr Array of functions that returns a promise
		 * @return {[type]}     Array of results of promises
		 */
		$q.allIterator = function promiseIterator( arr, interval ){

			if (typeof interval == "number") {
				arr = arr.map(function( prms ){
					return function() {
						return $timeout( prms, interval );
					};
				});
			} else if (typeof interval != "undefined") throw new Error( "Invalid argument! interval must be typeof number" );


			var response = new Array( arr.length );
			for (var i = 0; i < arr.length; i++) response[i] = null;

			return $q.when( handle( 0 ));


			function handle( itr ){
				if( !arr[ itr ]) return response;
				return arr[ itr ]().then(function( result ){
					response[ itr ] = result;
					return handle( itr+1 );
				});
			}
		};
	}

	var self = window.$User = $rootScope.$User = this;
	var _all_class = {
		"AA000000000000AB" : {
			uid              : "AA000000000000AB",
			title            : "*",
			parent_class_uid : null
		}
	};

	this.__ready  = null;

	this.logged   = null;
	this.uid      = null;
	this.configs  = null;

	this.classes  = null;
	this.groups   = null;
	this.clients  = null;

	this.isClient = null;

	this.getClientRole = function( client_uid ) {
		var clients = this.clients[client_uid];
		if (!clients) return null;

		if (!Array.isArray( clients )) return clients.$$userRole;

		var role = 0;
		for (var i in clients) role = Math.min( role, clients[i].role );

		return role;
	};

	this.setUser = function( user ){
		user = user || {};
		user.with = user.with || {};

		this.uid = user.uid || null
		this.logged  = !!this.uid;

		/***********************
		 * Prioriteettijärjestys:
		 * 1: Parametreilla asetetut(?)
		 * 2: APIlta saadut
		 * 3: localStoragesta ladatut
		 * 4: ???
		 * 5: Oletukset
		 */
		this.configs = {};

		this.display_name = "User";
		if ( this.logged ) {
			this.attributes = user;
			this.display_name = user.firstname || user.email || this.display_name;

			// Toivottavasti pääsee pian eroon
			if (user.active_preview_query_oeuvres_list_uid) this.configs.active_preview_query_oeuvres_list_uid = user.active_preview_query_oeuvres_list_uid;

			try {
				var ls_configs = this.loadLocalConfigs();
				for (var key in ls_configs) {
					if (!this.configs[ key ]) this.configs[ key ] = ls_configs[ key ];
				}
			} catch (err) {
				console.error( "Failed to load $User.configs from localStorage!", err );
			}

		} else {

		}

		this.classes    = user.with.classes    || {};
		this.clients    = user.with.clients    || {};
		this.groups     = user.with.groups     || {};
		this.interfaces = user.with.interfaces || {};
		if( Object.keys( this.interfaces ).length == 0 ) this.interfaces = null;

		this.preview_query_list_uid = user.active_preview_query_oeuvres_list_uid || null;

		this.isClient = Object.keys(this.clients).length > 0;

		if( this.isClient ){
			for( var client_uid in this.clients ){
				var client = this.clients[ client_uid ];
				client.$$userRole = 0;
				try {
					for( var i in client.with.user_client_mappings ){
						client.$$userRole = Math.max( client.$$userRole, client.with.user_client_mappings[i].role );
					}
				} catch( e ) { console.error( e ); }
			}
		}

		$userAssets.setClients( this.clients );

		try {
			(this.inDevelopement = !!(window.artestBaseDomain!='artest.net'&&this.classes["AA000000000002A7"])) ? enableDevelopement() : disableDevelopement();
		} catch( e ) { }
	}

	this.$logout = function(redirect_href) {
		$ApiHandler.clearAuthorization();
		if (!!redirect_href) location.href = redirect_href;
		else location.reload();
	}

	this.setUserLang = function( lang_id ) {
		if (typeof lang_id !== "string" || lang_id.length <2 )  throw new Error("Invalid argument");

		/** @TODO: Validoi */

		ipCookie("artest_lang", lang_id, { domain : ".artest.net", path : "/"});

		if (!!this.uid) {
			/** @TODO: Tallenna tietokantaan */
		}
	}

	this.setConfig = function( key, value ) {
		this.configs[ key ] = value;
		this.saveLocalConfig( key, value );
	}
	this.loadLocalConfigs = function(){
		return JSON.parse( localStorage.getItem( "user."+ (this.logged ? this.uid : "0000000000000000")  +".configs-v1" ) || "{}" );
	}	
	this.loadLocalConfig = function( key ){
		return this.loadLocalConfigs()[ key ];
	}
	this.saveLocalConfig = function( key, value, configs ){
		(configs = configs || this.loadLocalConfigs())[ key ] = value;

		if (typeof configs == "object") {
			console.log( "$User.saveLocalConfig() :: Saved key=value:", key, value, configs );
			localStorage.setItem( "user."+ (this.logged ? this.uid : "0000000000000000")  +".configs-v1", JSON.stringify( configs ));
		} else {
			console.error( "$User.saveLocalConfig() :: Invalid argument!", key, value, configs );
		}
	}


	/**
	 *
	 * mahdolliset tapaukset:
	 * - Api matalana
	 * - Api palauttaa oudon virheen
	 * - Api palauttaa tyhjÃ¤n kÃ¤yttÃ¤jÃ¤n
	 * - Kirjautumistietoja ei ole asetettu
	 * - Kirjautumistiedot on asetettu
	 *   - Tiedot oikeat
	 *   - Tiedot vÃ¤Ã¤rÃ¤t
	 */
	/* @TODO: Hyi. */
	this.refresh = function $UserRefresh(){

		self.__ready = $q.defer();

		$q(function(resolve, reject){
			var data;

			self.setUser(false);

			if (localStorage && (data = localStorage.getItem("api/users/me"))) {
				try {
					data = JSON.parse(data);
				} catch (e) { }

				if ( data && data.data && data.expires && Date.now() < data.expires ) {

					if ($ApiHandler.getAuthorization()) {
						console.debug("User data memorized:", data.data);
						return resolve(data.data);
					} else {
						console.debug("User data cleared");
						localStorage.removeItem("api/users/me");
					}
				}
			}

			$ApiHandler.get("/users/me", { filters:"onlydata,onlyattrs,asarray", with: "groups,clients,classes" })
			.then(function(response){
				console.debug("User data fetched:", response);
				try {
					if( Array.isArray(response.data) && response.data.length == 1 ){
						data = response.data[0];

						if( localStorage && localStorage.setItem ){
							localStorage.setItem("api/users/me", JSON.stringify({
								data    : data,
								expires : Date.now()+60000
							}));
						}

						resolve(data);
					} else throw new Error("Invalid response from api");
				} catch(err) {
					reject(err);
				}
			}).catch(reject);
		}).then(function(user){
			self.setUser(user);
		}).catch(function(err) {
			self.setUser(false);
			if (err.status == 403) {
				console.error("$User ::", "Forbidden! User not logged in!");
				$ApiHandler.clearAuthorization();
				self.__ready.resolve();
			} else {
				console.error("$User ::", "Could not fetch user data:", err);
				self.__ready.reject(err);
			}
		}).then(self.__ready.resolve);

		return self.__ready.promise;
	};

	this.refresh().catch(function(err){ console.error("Failed to initiate $User", err); });

	function disableDevelopement() {
		window.DEV = false;
	}
	function enableDevelopement() {
		window.DEV = true;

		var styles = document.querySelector("style.developement");
		if (!styles) {
			styles = document.createElement( "style" );
			styles.classList.add( "developement" );
			styles.innerText = 'body:not(.is-developer) .in-developement { display:none; } body.is-developer .in-developement:not(:hover) { outline: 2px dashed #000; outline-offset: 3px; box-shadow: 0px 0px 0px 5px yellow; }';
			document.head.append( styles );
		}
	}
}])

.service("$languageSelector", ["$rootScope", "$ApiHandler", "$q", "$sce", "gettextCatalog", "$User", "ipCookie"
                     , function($rootScope,   $ApiHandler,   $q,   $sce,   gettextCatalog,   $User,   ipCookie) {

	var self = this;
	this.languages = {};
	this.langs_available = false;
	this.languages_keys = {
		"fi_FI" : "fi",
		"en_UK" : "en",
		"en_GB" : "en",
		"en_US" : "en"
	};

	this.current_language = null;

	this.getCurrentLanguage = function() {
		return this.current_language = this.findLanguage(gettextCatalog.currentLanguage);
	}

	this.findLanguage = function( lang_id ) {
		var match;
		if (this.languages[lang_id]) {
			return this.languages[lang_id];
		} else if (this.languages_keys[lang_id]) {
			return this.languages[this.languages_keys[lang_id]];
		} else  if (match = lang_id.match(/^(\w\w)_\w\w$/)) {
			return this.languages[match[1]];
		} else return null;
	}


	this.set = function(lang_ids) {
		console.warn( "Please use .setLanguages()" );
		return this.setLanguages( lang_ids );
	}
	this.setLanguages = function setLanguages(lang_ids) {
		console.log( "$languageSelector.setLanguages() ::", lang_ids );

		if (lang_ids) {
			if (typeof lang_ids == "string") {
				return self.setLanguages( lang_ids.split(",") );
			}

			if (typeof lang_ids == "object" && !Array.isArray(lang_ids)) {
				return self.setLanguages(Object.keys( lang_ids ));
			}
		}

		return $q(function( resolve, reject ){
			var where = {};
			try {
				if (!!lang_ids) {
					// Varmistetaan, että käsitellään vain taulukkoa (note: taulukollista merkkijonoja)
					if (!Array.isArray( lang_ids )) {
						console.error(   "Invalid argument at $languageSelector.setLanguages()", lang_ids );
						throw new Error( "Invalid argument at $languageSelector.setLanguages()" );
					}
	
					self.clear();
					for (var i in lang_ids) {
						self.languages[lang_ids[i]] = {
							description    : "",
							dir_rtl        : false,
							lang_id        : lang_ids[i],
							local_title    : "Loading...",
							title          : "Loading...",
							sce_html_title : $sce.trustAsHtml("Loading...")
						}
					}
					where = JSON.stringify({ lang_id : { $in : lang_ids } });
				} else {
					self.clear();
				}

			} catch ( err ) {
				return reject( err );
			}

			resolve( where );
		}).then(function( where ) {
			return $q.when(window.__ARTEST_LANGUAGES || (window.__ARTEST_LANGUAGES = $ApiHandler.get("/languages", {
				where   : where,
				filters : "onlydata,onlyattrs,asarray"
			}).then(function( response ) {
				return window.__ARTEST_LANGUAGES = response.data;
			})));
		}).then(function( response ){
			var lang, count = 0;

			for(var i in response){
				lang = response[i];
				lang.sce_html_title = $sce.trustAsHtml(lang.local_title || lang.title || lang.lang_id);
				lang.available = false;
				self.languages[lang.lang_id] = lang;
			}

			for( var key in gettextCatalog.strings ) {
				var lang = self.findLanguage(key);
				if (lang && self.languages[lang.lang_id]) {
					self.languages[lang.lang_id].available = true;
					count++;
				}
			}

			self.langs_available = (count > 0);

			return self.languages;
		});
	};
	this.clear = function(){
		for (var key in this.languages = this.languages || {}) {
			delete this.languages[ key ];
		}
	};

	this.changeLanguage = function(lang_id) {
		if (!lang_id) return;

		var language = this.current_language = this.findLanguage(lang_id);
		lang_id = language.lang_id;

		if (language) {
			console.log("$rootScope.$broadcast(\"language.changed\", "+lang_id+")");

			var i18n_keys = Object.keys(gettextCatalog.strings), found = false;
			for( var i in i18n_keys ) {
				if (i18n_keys[i].indexOf(lang_id) == 0) {
					gettextCatalog.setCurrentLanguage(found = i18n_keys[i]);
					break;
				}
			}
			$User.setUserLang(language.lang_id);
			if (!found)  {
				gettextCatalog.setCurrentLanguage(null);
				console.error("No translations found with given lang '"+lang_id+"'");
			} else {
				ipCookie("artest_lang", language.lang_id, { domain : ".artest.net", path : "/"});
				$rootScope.$broadcast("language.changed", language);

				try {
//					angular.element(document.body).injector().get("Notification").info( "Please note, that some of the translations needs page reload to get in use!" );
				} catch(err) { console.error( err ); }
			}
		} else {
			console.error("Invalid argument at $languageSelector.changeLanguage(): language '"+ lang_id +"' not found");
			throw new Error("Invalid argument at $languageSelector.changeLanguage(): language '"+ lang_id +"' not found");
		}
	}
}])

.run([        "ipCookie","$rootScope","$window","$injector","$http","$q","$User","$languageSelector","$timeout","gettextCatalog","$compile","modalOpenerGenerator","artestUserBarService"
    , function(ipCookie,  $rootScope,  $window,  $injector,  $http,  $q,  $User,  $languageSelector,  $timeout,  gettextCatalog,  $compile,  modalOpenerGenerator,  artestUserBarService ){

	/**************************/
	var $state = null;
	try {
		$state = $injector.get ("$state" );
	} catch( err ) {
		console.warn( "Failed to get $state to use", err );
		console.debug( "$state poistettu ArtestUserBar:n riippuvuuksista 22.5.2020" );
	}
	/**************************/

	$q.resolve( false ).then(function( message ) {

		if (!message) return;

		var e = document.createElement("div");
		e.innerHTML = message;
		e.style.position = "fixed";
		e.style.bottom = "0px";
		e.style.left = "0px";
		e.style.right = "0px";
		e.style.zIndex = "99999";
		e.style.backgroundColor = "#ffffff";
		e.style.padding = "0.5em";
		e.style.borderTop = "1px solid #ddd";
		document.body.appendChild( e );

		var btn = document.createElement("a");
		btn.innerHTML = "&Cross;";
		btn.onclick = function(){ e.remove(); };
		btn.href = "javascript:;";
		btn.style.padding = "0.5em";
		e.prepend(btn);

	}).catch(function( error ) {
		console.error( error );
	});

	$rootScope.$ArtestUserBarService = artestUserBarService;

	if (window.artestBaseDomain!="artest.net") {
	    $rootScope.kaannoksetPaalle = window.kaannoksetPaalle = function(){
	        return $timeout(function(){
	            gettextCatalog.debug = true;
	            return $state && $state.reload();
	        });
	    }

	}

	try {
		Object.defineProperty( window, 'DEV', {
			set: function( val ) {
				console.debug( "$rootScope.DEV =", $rootScope.DEV = !!val );
				if ($rootScope.DEV) {
					document.body.classList.add( "is-developer" );
				} else {
					document.body.classList.remove( "is-developer" );
				}
			},
			get: function() {
				return $rootScope.DEV;
			}
		});
		window.DEV = false;
	} catch ( error ) { }

	gettextCatalog.baseLanguage = "en_GB";

	$rootScope.setLang = function( lang_code, lang_cookie ) {

		if ((lang_code = solveLang(lang_code)) == null) return ipCookie( lang_cookie );

		$languageSelector.getCurrentLanguage();

		document.querySelector("html").lang = lang_code;

		if (!!lang_cookie) ipCookie(lang_cookie, lang_code, { path : "/", domain : ".artest.net" });

		var prmss = [];

		try {
			prmss.push((function( lang_id, tmhDynamicLocale ) {
				return function() {
					switch( lang_id ) {
						case "fi_FI":
							return tmhDynamicLocale.set( 'fi-fi' );
							break;
						default:
							return tmhDynamicLocale.set( 'en-us' );
					}
					return $q.when( null );
				};
			})( lang_code, $injector.get( "tmhDynamicLocale" ) ));
		} catch( err ) { console.error( "$rootScope.setLang :: Failed to initiate angular-i18n lazy loading" ); }

		try {
			if (!gettextCatalog.strings[ lang_code ]) {
				prmss.push((function( lang_id ){
					return function() {
						return gettextCatalog.loadRemote( "i18n/translations/"+ lang_id +".json" );
					};
				})( lang_code ));
			}
		} catch( err ) { console.error( "$rootScope.setLang :: Failed to initiate lang_id.json lazy loading" ); }

		$q.allIterator( prmss.map(function( fn ){
			return function(){
				return fn().catch(function( err ){
					console.error( "$rootScope.setLang :: Got error while setting language " + lang_code, err );
				});
			};
		})).then(function( result ){
			console.log( "$rootScope.setLang :: Loaded translations!", result );

			gettextCatalog.setCurrentLanguage( lang_code );

			return lang_code
		});

		return lang_code;

		function solveLang( lang, fallback ) {
			fallback = typeof fallback == "undefined" ? "fi_FI" : fallback;

			switch( lang ) {
				case "fi":
				case "fi_FI":
					return "fi_FI";

				case "en":
				case "en_EN":
				case "en_US":
				case "en_UK":
				case "en_GB":
					return "en_GB";

				default:
					console.error( "No language '"+lang+"' available!" );
					break;

				case undefined:
					break;
			}
			return fallback;
		}
	}

	$languageSelector.setLanguages().finally(function(){
		$rootScope.lang_code = (function(lang_cookie) {
			return $rootScope.setLang(ipCookie(lang_cookie), lang_cookie);
		})("artest_lang");
	});

	$rootScope.$on("language.changed", function(event, lang){
		$rootScope.setLang(lang.lang_id, "artest_lang");
	});

	(function( onScroll ){
		angular.element( $window ).on( "scroll", onScroll );
		$rootScope.$on( "$destroy", function(){
			angular.element( $window ).off( "scroll", onScroll );
		});
	})(function(){
		$rootScope.$broadcast( "$scroll", window.scrollY );
	});

	$User.__ready.promise.then(function(){
		console.log("$User ready!");
	}).catch(function(err){
		console.log("$User failed!", err);
	}).finally(function(){
		setTimeout(function(){
			$http({ url: '/ajax/cms/partials/artest.user.bar.css' }).then(function( response ){
				var css = response.data;
				angular.element(document.head).append(angular.element("<style type='text/css'>").text(css));
				var elem = angular.element("<div artest-user-bar class='partial-main-content'></div>");
				angular.element(document.body).addClass("artestUserBar-available").prepend(elem);
				return $compile(elem)($rootScope.$new());
			}).catch(function(error){
				console.error(error);
			});
		}, 2000);
	});

	$rootScope.artestBaseDomain = window.artestBaseDomain;
	$rootScope.artestRootDomain = window.artestRootDomain;
	$rootScope.artestApiDomain = window.artestApiDomain;

	$rootScope.__artestUserBar_ready = $q.defer();

	$rootScope.logged = null;

	$rootScope.queryParams = (function(qs, params, tokens, re) {
		qs = qs.split('+').join(' ');
		while (tokens = re.exec(qs))
			params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
		return params;
	}).call(null, location.search, {}, undefined, /[?&]?([^=]+)=([^&]*)/g);

}])

.service("$artestTools", [ "modalOpenerGenerator",
                  function( modalOpenerGenerator ){

	this.openAuctionPlaceABidModal = modalOpenerGenerator.generate( "auctions-place-a-bid", {
		templateUrl        : "/ajax/cms/partials/modal.auctions-place-a-bid.html",
		controllerBasepath : "/libs/cms/controllers/",
		size               : "lg"
	}, [ "auction" ]);

}])

.directive("artestUserBar", function(){
	return {
        templateUrl  : "/ajax/cms/partials/artest.user.bar.html",
		replace      : true,
		controller   : ["$scope", "$rootScope", "ipCookie", "$element", "$injector", "$User", "artestUserBarService", "$languageSelector",
		        function($scope,   $rootScope,   ipCookie,   $element,   $injector,   $User,   artestUserBarService,   $languageSelector){

			this.$scope = $scope;

			var client = $scope.client;
			var $ApiHandler = null;

			$scope.cms = (function(s){return s && s.cms})(angular.element(document.body).scope()) || null;
			$scope.$User = $User;
			$scope.$languageSelector = $languageSelector;

			$scope.pageState = {
				context : window.artest_current_page_context || null,
				display : {
					"login-btn"       : true,
					"signup-btn"      : true,
					"language-switch" : true,
					"search-form"     : true
				}
			}

			$scope.branding_logo_src = "https://artest.net/libs/cms/img/header-brand.png";

			$scope.goToFrontpage = function() {
				return artestUserBarService.brandingLogoClick();
			};

			$scope.openHelpcenterModal = function(){
				return artestUserBarService.OpenHelpCenterModal();
			};

			$scope.searchFormFocus = false;
			$scope.$watch("searchFormFocus", function(){
			})

			setTimeout(function(){
				angular.element(window).triggerHandler('resize.search-bar-fitter');
			}, 1000);

			switch($scope.pageState.context) {
				case "login":
					$scope.pageState.display["login-btn"] = false;
					$scope.pageState.display["language-switch"] = false;
					break;
			}

			$scope.oeuvresBasket = {
				open : false
			}

			try {
				$ApiHandler = $injector.get("$ApiHandler");
			} catch(e) {
				$Apihandler = function(){ return $q(function(resolve, reject){ reject(new Error("$ApiHandler not available!")); }) }
			}

			$scope.languages = {};

			try {
				angular.element(document.body).injector("").get("language");
			} catch(e) {
				$scope.languages = null;
			}

			$scope.goToLogin = function(){
				location.href = $scope.genLoginHref();
			}

			$scope.genLoginHref = function( redirect ){
				var url = "/auth/login";
				if( redirect = redirect || ( location.pathname+location.hash )){
					if( redirect == "/" ) redirect = "/dashboard";
					url += "?redirect="+ encodeURIComponent(redirect);
				}
				return url;
			}

			$rootScope.__artestUserBar_ready.resolve( $scope );

			artestUserBarService.registerUserBarInstance( this );
		}]
	}
})

.service("artestUserBarService", ["$rootScope","$injector","$timeout","$templateCache","modalOpenerGenerator",
                         function( $rootScope,  $injector,  $timeout,  $templateCache,  modalOpenerGenerator ){

	/**************************/
	var $state = null;
	try {
		$state = $injector.get ("$state" );
	} catch( err ) {
		console.warn( "Failed to get $state to use", err );
		console.debug( "$state poistettu ArtestUserBar:n riippuvuuksista 22.5.2020" );
	}
	/**************************/

	this.$userBarInstance = null;
	this.$userBarInstanceOptions = {
		branding_logo_src: undefined
	}

	this.registerUserBarInstance = instance => {
		console.debug("registerUserBarInstance()", instance)
		this.$userBarInstance = instance;

		try {
			if (this.$userBarInstanceOptions.branding_logo_src) {
				this.$userBarInstance.$scope.branding_logo_src = this.$userBarInstanceOptions.branding_logo_src;
			}
		} catch (e) {
			console.error(e)
		}
	}

	this.getUserBarElem = (function( elem ) {
		return function() {
			return elem || (elem = document.getElementById("artestUserBar"));
		}
	})();

	this.getUserBarHeight = function() {
		try {
			return this.getUserBarElem().clientHeight;
		} catch ( error ) {
			console.error( error );
		}
		return 0;
	}

	this.brandingLogoClick = function() {
		var fn = this.brandingLogoClick_genFn();
		return $timeout(function() {
			try {
				if (typeof fn === "function") return fn();
			} catch( err ){
				console.error( "artestUserBarService.brandingLogoClick :: Failed to handle click", err );
			}
		});
	};

	this.brandingLogoClick_genFn = function() {
		try {
			if ($rootScope.atm_at_cmsengine) {
				if (!($rootScope.editor && $rootScope.editor.enabled)) {
					return function() {
						var frontpage_uid = angular.element(document.body).injector().get("$clientData").frontpage;
						console.log( "Going to frontpage", frontpage_uid );
						$state && $state.go(frontpage_uid);
					};
				}
			} else if ($rootScope.atm_at_preview) {
				if ($state && $state.current.name == "project.wall-arrangement.preview") {
					return function() {
						$state && $state.go("project.view");
					}
				}
			}
		} catch( err ){
			console.error( "artestUserBarService.brandingLogoClick_genFn", err );
		}
	};

	this.setBrandingLogoSrc = function( src ) {
		if (this.$userBarInstance) {
			this.$userBarInstance.$scope.branding_logo_src = src;
		} else {
			this.$userBarInstanceOptions.branding_logo_src = src;
		}
	};

	this.setHeadTitle = (function( title_elem ) {
		return function( title ) {
			$timeout(function(){
				document.title = title || "Artest";
			}, 0, false);
		};
	})();

	this.OpenOeuvreViewerModal = modalOpenerGenerator.generate( "oeuvre-viewer", {
		templateUrl        : "/ajax/cms/partials/modal.oeuvre-viewer.html",
		controllerBasepath : "/libs/cms/controllers/",
		size               : "lg"
	}, [ "oeuvre" ]);

	this.OpenShareOeuvreModal = modalOpenerGenerator.generate( "share-oeuvre", {
		templateUrl        : "/ajax/cms/partials/modal.share-oeuvre.html",
		controllerBasepath : "/libs/cms/controllers/",
		size               : "md"
	}, [ "oeuvre" ]);

	this.OpenHelpCenterModal = modalOpenerGenerator.generate( "helpcenter", {
		templateUrl        : "/ajax/cms/partials/modal.helpcenter.html",
		controllerBasepath : "/libs/cms/controllers/",
		size               : "lg"
	});

	this.OpenOeuvresImporterModal = modalOpenerGenerator.generate( "oeuvres-importer", {
		templateUrl        : "/ajax/cms/partials/modal.oeuvres-importer.html",
		controllerBasepath : "/libs/cms/controllers/",
		size               : "lg"
	}, [ "selectedOeuvres" ]);

	this.OpenFileExplorerModal = modalOpenerGenerator.generate( "file-explorer", {
		templateUrl        : "/ajax/cms/partials/modal.file-explorer.html",
		controllerBasepath : "/libs/cms/controllers/",
		size               : "lg"
	});

	this.OpenFileGalleryModal = modalOpenerGenerator.generate( "file-gallery", {
		templateUrl        : "/ajax/cms/partials/modal.file-gallery.html",
		controllerBasepath : "/libs/cms/controllers/",
		size               : "lg"
	}, [ "imagefiles", "oeuvreinfo" ]);

	this.OpenObjectProcedureCreatorModal = modalOpenerGenerator.generate( "object_procedure-creator", {
		templateUrl: "/ajax/cms/partials/modal.object_procedure-creator.html",
		controllerBasepath: "/libs/cms/controllers/",
		size: "lg",
		backdrop: "static",
		keyboard: false
	}, [ ]);

	modalOpenerGenerator.generate( "resource-access-controls", {
		templateUrl: "/ajax/cms/partials/modal.resource-access-controls.html",
		controllerBasepath: "/libs/cms/controllers/",
		size: "lg",
		backdrop: "static",
		keyboard: false
	});						 	

	modalOpenerGenerator.generate( "file-previewer", {
		templateUrl: "/ajax/cms/partials/modal.file-previewer.html",
		controllerBasepath: "/libs/cms/controllers/",
		size: "lg",
		backdrop: true,
		keyboard: false
	});						 	

	$templateCache.put( "uib/template/tabs/tab.html", "<li ng-class=\"[{active: active, disabled: disabled}, classes]\" class=\"uib-tab nav-item\"><a href ng-click=\"select($event)\" class=\"nav-link\" uib-tab-heading-transclude>{{heading}}</a> </li>" );

	$templateCache.put( "uib/template/tabs/tabset.html", "<div><ul class=\"nav nav-{{tabset.type || 'tabs'}}\" ng-class=\"{'nav-stacked': vertical, 'nav-justified': justified}\" ng-transclude></ul><div class=\"tab-content\"><div class=\"tab-pane\" ng-repeat=\"tab in tabset.tabs\" ng-class=\"{active: tabset.active === tab.index}\" uib-tab-content-transclude=\"tab\"></div></div></div>" );

}])

.directive('artestPreviewQueryDefault', function() {
    return {
        replace: true,
        templateUrl: "/ajax/cms/partials/artest.preview.query.html"
    };
})

.controller("weUseCookiesController", [ "$scope", "$element", "ipCookie", function( $scope, $element, ipCookie ) {
	$scope.okyet = ipCookie( "artest-cookies-ok" ) || undefined;

	if (!!$scope.okyet) return $element.remove();

	$scope.cookiesOk = function(){
		$scope.okyet = Date.now();
		ipCookie("artest-cookies-ok", $scope.okyet, { domain : "artest.net" });
		$element.remove();
	}
}])

.controller('loginPopoverController', function ($scope, $sce) {
	$scope.templateUrl = 'loginPopoverTemplate.html';
	$scope.title = "title";
})

.directive('nsFocusTo', ['$timeout', function($timeout) {
	return {
		restrict: 'A',
		link: function(scope, element, attrs, ctrl) {
			element.click(function() {
				$timeout(function () {
					console.log(attrs.nsFocusTo, angular.element(attrs.nsFocusTo).focus());
				}, 0);
			});
		}
	};
}])

.filter('toArray', function() {
	return function(obj) {
		if (!(obj instanceof Object)) return obj;

		return Object.keys(obj).map(function( key ) {
			return Object.defineProperty( obj[key], '$key', { __proto__: null, value: key });
		});
	};
})

.filter('objLength', function() {
	return function(arg) {
		if (arg == null || typeof arg != "object") return NaN;
		return Object.keys( arg ).length;
	}
})
.directive('includeReplace', function() {
	return {
		require: 'ngInclude',
		restrict: 'A', /* optional */
		link: function( scope, el, attrs ){
			el.replaceWith( el.children());
		}
	};
})

.directive('artestUserBarSearchWrapper', [ "$compile", "$timeout", "$rootScope", "$q", function( $compile, $timeout, $rootScope, $q ){ 
	return {
		link: function( scope, element, attrs ){
			$timeout(function() {
				return window.controllerResolverRaw( "/libs/cms/", "artestUserBarSearchController", "ArtestUserBarSearch" )[2]( $rootScope, $q );
			}, 500 ).then(function(){
				element.html('<div ng-include="\'/ajax/cms/partials/ArtestUserBarSearch.html\'"></div>');
				$compile(element.contents())(scope);
			}).catch( function( error ){
				console.error( "artest.user.bar.directive(artestUserBarSearchWrapper)", error );
			});
		}
	};
}])


.directive( 'closeableInfo', ["$User", function( $User ){
	return {
		restrict: 'A',
		link: function(scope, elem, attrs, ctrl) {
			var closeBtn = angular.element( '<a class="close-btn btn btn-xs btn-default" style="margin-right:5px"><b class="glyphicon glyphicon-remove"></b></a>');
			closeBtn.on( 'click', closeFn );
			elem.addClass( "closeable-info" ).prepend( closeBtn );

			if (attrs.closeableInfo) {
				try {
					var v = $User.loadLocalConfig( "closeable-info." + attrs.closeableInfo + ".closed" );
					if (v) closeFn();
				} catch( err ) { console.error( err ); }
			}

			function closeFn( ){
				elem.css("display", "none");
				if (attrs.closeableInfo) {
					$User.setConfig( "closeable-info." + attrs.closeableInfo + ".closed", true );
				}
			};
		}
	}
}])

.directive('inDevelopement', ['$rootScope', '$timeout', function( $rootScope, $timeout ) {
	return {
		restrict: 'C',
		link: function(scope, element, attrs, ctrl) {
			$rootScope.$watch("DEV", function( dev ){
				if (!!dev) element.show();
				else element.hide();	
			});
		}
	};
}])

.directive( 'style', function(){
	return {
		restrict: 'E',
		controller: [ "$element", function( e ){
			e = e[0];
			if (e.type != "text/less") return;
			if (window.less) compileInnerCSS(e);
			else {
				debugger;
			}
		}]
	};
	function compileInnerCSS( element ) {
		debugger;
	}
})

.directive( "verticalDropdownAdjust", [ "$rootScope", "$timeout", function( $rootScope, $timeout ) {

	var top_margin = 55;
	var bottom_margin = 55;

	return {
		require: "uibDropdown",
		restrict: "A",
		link: function link( scope, element, attrs, controller ) {

			scope.$watch( controller.isOpen, runVerticalDropdownAdjust );

			angular.element( window ).on( "resize", runVerticalDropdownAdjust );

			function runVerticalDropdownAdjust() {

				if (controller.isOpen()) {

					$timeout(function() {

						var height = controller.dropdownMenu.height();
						var top    = controller.dropdownMenu.offset().top - window.scrollY;
						var bottom = top + height;

						// Liitoiteltu erotus ruudun alareunan ja valikon alareunan välissä
						var diff = ( bottom - window.innerHeight ) + top_margin;

						if (diff > 0) {
							// Varmistetaan ettei siirretä valikkoa ruudun yläreunan yli
							diff = Math.min( diff, top - top_margin );

							controller.dropdownMenu.css( "top", (controller.dropdownMenu.position().top - diff) + "px" );

							try {
								var max_height = window.innerHeight - top_margin - bottom_margin;

								controller.dropdownMenu.css({
									"height"     : (height > max_height ? max_height + "px" : ""),
									"max-height" : max_height + "px",
									"overflow-y" : "auto"
								});

							} catch (err) { console.error( err ); }
						}
					});
				}
			}
		}
	}
}])

.service( "modalOpener", [ "$timeout", "$rootScope", function( $timeout, $rootScope ){
	var openFns = {};

	this.registerModal             = registerModal;
	this.openRegisteredModal       = openRegisteredModal;

	$rootScope.openRegisteredModal = openRegisteredModal;

	function openRegisteredModal( key, argv1, argv2, argv3, argv4 ) {
		return $timeout( getRegisteredModal, 0, true, key ).then(function( openFn ) {
			return openFn( argv1, argv2, argv3, argv4 );
		});
	}

	function registerModal( name, openFn ) {
		openFns[ name ] = openFn;
	}


	function getRegisteredModal( key ) {
		if (typeof key != "string") throw "Invalid key";
		if (typeof openFns[ key ] !== "function") throw "Invalid key";

		return openFns[ key ];
	}
}])

.service( "modalOpenerGenerator", [ "$uibModal", "$rootScope", "modalOpener", function( $uibModal, $rootScope, modalOpener ){
	this.generate = function modalOpenerGenerator( key, opts, resolveKeys ){
		opts = opts || {};
		var _resolve = opts.resolve || {};
		var _templateUrl        = opts.templateUrl        || "templates/modal."+ key +".html";
		opts.controller         = opts.controller         || "modal."+ key;
		opts.controllerBasepath = opts.controllerBasepath || "js/controllers/";
		opts.animation          = opts.animation != null ? opts.animation : false;
		opts.windowClass = key;

		resolveKeys = resolveKeys || [];
		resolveKeys.push( "$modalOpts" );

		var openFn = function(){
			var resolve = {};
			for( var i = 0; i < resolveKeys.length; i++ ) resolve[ resolveKeys[i] ] = arguments[i] || undefined;

			resolve["$modalOpts"] = resolve["$modalOpts"] || {};

			return fn( resolve );
		};

		modalOpener.registerModal( key, openFn );

		return openFn;

		function fn( resolve ){
			opts.resolve = resolve || {};
			for( var i in _resolve ) opts.resolve[ i ] = opts.resolve[ i ] || _resolve[ i ];

			opts.resolve.ctrl = window.controllerResolverRaw( opts.controllerBasepath, opts.controller );
			opts.templateUrl = _templateUrl +"?_="+ ($rootScope.DEV ? Date.now() : 0);

			var modal = $uibModal.open( opts );

			return modal.result.catch(function( error ){
				if (error == "backdrop click" || error == "escape key press") return null;

				console.error( error );
				throw error;
			});
		}
	}
}]);

